export default "/images/vendor/flag-icon-css/flags/4x3/es.svg?1a25a96e26fcca676c08fb109bcec333";